const testimonials = [
  {
    name: 'Justin & Briar Bloomfield',
    location: 'Wellington',
    rating: 5,
    title: 'No job too big or small!',
    text: 'Thanks for sorting out our renovations, no job too big or small for the guys at Alfa. Very professional service.',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20couple%20professional%20headshot%20natural%20light%20warm%20background%20Wellington%20New%20Zealand%20approachable%20genuine%20smile&width=80&height=80&seq=tav3001&orientation=squarish',
  },
  {
    name: 'Ilostma Donkey',
    location: 'Wellington',
    rating: 5,
    title: 'Attention to detail is outstanding',
    text: 'Really stoked with Alfa Decorators. Clean, tidy, very fussy with an attention to detail. Would certainly recommend to others.',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20professional%20headshot%20natural%20light%20warm%20background%20Wellington%20New%20Zealand%20approachable%20genuine%20smile%2045%20years%20old&width=80&height=80&seq=tav3002&orientation=squarish',
  },
  {
    name: 'Lynette Belt',
    location: 'Wellington',
    rating: 5,
    title: 'Highly recommend Alfa Decorators!',
    text: 'Extremely pleased with Alfa Decorators. I have had Andres do a variety of jobs as I prepared my house for sale and then moved into a new one. Andres is totally professional, reliable, consults regularly and comes up with good solutions. His time management is impressive and he forward plans for all contingencies. His work is of the highest standard and he will happily go the extra mile.',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20woman%20professional%20headshot%20natural%20light%20warm%20background%20Wellington%20New%20Zealand%20approachable%20genuine%20smile%2055%20years%20old&width=80&height=80&seq=tav3003&orientation=squarish',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-20 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-[#2D2D2D] text-sm font-semibold tracking-widest uppercase mb-3">Reviews</span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight mb-4">What Our Clients Say</h2>
          <div className="flex items-center justify-center gap-2">
            {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-amber-400 text-lg" />)}
            <span className="text-gray-500 text-sm ml-2">5.0 average from reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-white rounded-2xl p-7">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-base">{t.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed mb-5">{t.text}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-[#F0F0F0] flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-[#2D2D2D] text-lg" />
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-900">{t.name}</div>
                  <div className="text-xs text-gray-400">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
